export enum BreakdownTypes {
  ItemsTotal = 'itemsTotal',
  Shipping = 'shipping',
  Tax = 'tax',
  Discount = 'discount',
}

export interface PaymentBreakdown {
  [BreakdownTypes.ItemsTotal]: string;
  [BreakdownTypes.Shipping]?: string;
  [BreakdownTypes.Tax]?: string;
  [BreakdownTypes.Discount]?: string;
}
